<template>
  <div>
    <!-- 具体要求选择 -->
    <el-dialog :title="$t('message.specificRequirementsSelection')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <!-- 当前任务类型：检品操作抽查 -->
        <div class="row">
          <div class="label">
            当前任务类型：{{ typeName }}
          </div>
          <!-- 加入任务 -->
          <el-button type="primary" @click="addToTask">{{ $t('message.addToTask') }}</el-button>
        </div>
        <div class="table">
          <ol>
            <li>
            </li>
            <li>
              ID
            </li>
            <!-- 具体要求 -->
            <li class="flex6">
              {{ $t("message.specificRequirements") }}
            </li>
          </ol>
          <ul v-for="(item, index) in tableData" :key="index">
            <li>
              <el-checkbox v-model="item.checked"></el-checkbox>
            </li>
            <li>
              {{ item.id }}
            </li>
            <!-- 具体要求 -->
            <li class="flex6">
              {{ item.desc }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    typeName: { type: String }
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },

  methods: {

    //任务要求配置-列表
    expectList() {
      this.$api.spotCheckApi.expectList({ page: 1, pageSize: 999 }).then(res => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data
        this.dialogVisible = true
      })
    },
    // 加入任务
    addToTask() {
      let list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      if (list == false) return this.$message.error('请选择具体抽查要求')
      this.$parent.addToTask(list)
      this.dialogVisible = false
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;


    .label {
      line-height: 40px;
    }


  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
      height: 50px;
    }

    ul {
      display: flex;
      padding: 0;
      background-color: #fff;

      li {
        padding: 20px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex6 {
      flex: 6;
    }
  }


}
</style>